import React from "react";

export const Youtube = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z"
        fill="white"
      />
      <path
        d="M27.8406 16.8002C27.8406 16.8002 27.6844 15.6971 27.2031 15.2127C26.5938 14.5752 25.9125 14.5721 25.6 14.5346C23.3625 14.3721 20.0031 14.3721 20.0031 14.3721H19.9969C19.9969 14.3721 16.6375 14.3721 14.4 14.5346C14.0875 14.5721 13.4062 14.5752 12.7969 15.2127C12.3156 15.6971 12.1625 16.8002 12.1625 16.8002C12.1625 16.8002 12 18.0971 12 19.3908V20.6033C12 21.8971 12.1594 23.1939 12.1594 23.1939C12.1594 23.1939 12.3156 24.2971 12.7937 24.7814C13.4031 25.4189 14.2031 25.3971 14.5594 25.4658C15.8406 25.5877 20 25.6252 20 25.6252C20 25.6252 23.3625 25.6189 25.6 25.4596C25.9125 25.4221 26.5938 25.4189 27.2031 24.7814C27.6844 24.2971 27.8406 23.1939 27.8406 23.1939C27.8406 23.1939 28 21.9002 28 20.6033V19.3908C28 18.0971 27.8406 16.8002 27.8406 16.8002ZM18.3469 22.0752V17.5783L22.6687 19.8346L18.3469 22.0752Z"
        fill="#6C3BC7"
        fillOpacity="0.8"
      />
    </svg>
  );
};
